import {
  GRANDE_TESTE_GRUPOS,
  GRANDE_TESTE_PERGUNTAS,
  type GrandeTesteGrupo,
  type GrandeTestePergunta,
} from '@/data/grandeTesteData';

export interface GrupoOverride {
  id: string;
  label: string;
  titulo: string;
  tipo: GrandeTesteGrupo['tipo'];
  ativo?: boolean;
  hard_deleted?: boolean;
}

export interface PerguntaOverride {
  id: string;
  grupo_id: string;
  persona_slug: GrandeTestePergunta['personaSlug'];
  texto: string;
  imagens?: string[];
  imagens_genero?: GrandeTestePergunta['imagensGenero'];
}

/** Missing database rows keep the synchronized local content, not an outdated total. */
export function resolveGrandeTesteContent(dbGrupos: GrupoOverride[] = [], dbPerguntas: PerguntaOverride[] = []) {
  const byId = new Map(dbGrupos.map((grupo) => [grupo.id, grupo]));
  const grupos: GrandeTesteGrupo[] = [];
  for (const local of GRANDE_TESTE_GRUPOS) {
    const grupo = byId.get(local.id);
    if (grupo ? grupo.ativo === false || grupo.hard_deleted === true : local.ativo === false) continue;
    grupos.push(grupo ? { id: grupo.id, label: grupo.label, titulo: grupo.titulo, tipo: grupo.tipo } : local);
  }
  for (const grupo of dbGrupos) {
    if (!GRANDE_TESTE_GRUPOS.some((local) => local.id === grupo.id) && grupo.ativo !== false && !grupo.hard_deleted) {
      grupos.push({ id: grupo.id, label: grupo.label, titulo: grupo.titulo, tipo: grupo.tipo });
    }
  }
  const pById = new Map(dbPerguntas.map((pergunta) => [pergunta.id, pergunta]));
  const activeIds = new Set(grupos.map((grupo) => grupo.id));
  const fromDB = (p: PerguntaOverride): GrandeTestePergunta => ({
    id: p.id, grupoId: p.grupo_id, personaSlug: p.persona_slug,
    texto: p.texto || '', imagens: p.imagens || [], imagensGenero: p.imagens_genero || [],
  });
  const perguntas = GRANDE_TESTE_PERGUNTAS.map((local) => {
    const db = pById.get(local.id);
    return db ? fromDB(db) : local;
  });
  for (const p of dbPerguntas) {
    if (!GRANDE_TESTE_PERGUNTAS.some((local) => local.id === p.id)) perguntas.push(fromDB(p));
  }
  return { grupos, perguntas: perguntas.filter((p) => activeIds.has(p.grupoId)) };
}